/**
 * @license
 * Copyright 2021 Google LLC
 * SPDX-LIcense-Identifier: Apache-2.0
 */
import {css} from 'lit';
export const styles = css`:host{display:block;--mdc-theme-text-primary-on-background: var(--fds-on-background, rgba(0, 0, 0, 0.75));--mdc-ripple-color: var(--fds-primary, #694ed6);--mdc-menu-item-height: var(--fds-menu-item-height, 48px);--mdc-menu-max-width: var(--fds-menu-max-width, calc(100vw - 32px));--mdc-menu-min-width: var(--fds-menu-min-width, 112px);--mdc-menu-max-height: var(--fds-menu-max-height, calc(100vh - 32px));--mdc-menu-z-index: var(--fds-menu-z-index, 8)}`;
